<template>
    <div>
        <img :src="'/media/header/gym.jpg'" alt="Gym" class="img-fluid mb-4 rounded">

        <div class="card shadow-sm sticky-top mb-4" ref="filterCard">
            <div class="card-body">
<!--                <h5 class="card-title text-primary oswald">-->
<!--                    Filter-->
<!--                </h5>-->
<!--                <hr>-->

                <div class="row">
                    <div class="col-12 col-md-3 mb-2 mb-lg-1">
                        <strong class="mb-2">{{ $t('pages.gym.search') }}</strong>
                        <div class="form-group">
                            <input type="text" class="form-control" :placeholder="$t('pages.gym.search')" v-model="filter.search" :class="{'is-invalid': $errors.has('q')}">
                            <error input="q"/>
                        </div>
                    </div>

                    <div class="col-12 col-md-3 mb-2 mb-lg-1">
                        <strong class="mb-2">{{ $t('pages.admin.video.upload.focuses_on') }}</strong>
                        <div class="from-group">
                            <v-select multiple v-model="filter.goals" :options="goals" :reduce="goal => goal.id" />
                        </div>
                    </div>

                    <div class="col-12 col-md-3 mb-2 mb-lg-1">
                        <strong class="mb-2">{{ $t('pages.gym.intensity_max') }}</strong>
                        <div class="form-group">
                            {{ filter.max_intensity }}
                            <range-slider id="max_intensity" class="slider mt-2" min="1" max="10" step="1" v-model="filter.max_intensity"/>
                            <error input="max_intensity"/>
                        </div>
                    </div>

                    <div class="col-12 col-md-3 mb-2 mb-lg-1">
                        <strong class="mb-2">{{ $t('pages.gym.duration_max') }}</strong>
                        <div class="form-group">
                            <span>{{ $t('pages.gym.minutes', {minutes: filter.max_duration}) }}</span>
                            <range-slider id="max_duration" class="slider mt-2" min="10" max="90" step="5" v-model="filter.max_duration"/>
                            <error input="max_duration"/>
                        </div>
                    </div>

                </div>

                <strong>{{ $t('pages.gym.level') }}</strong>
                <br>
                <div class="form-inline">
                    <div class="mr-3 form-check" v-for="level in levels" :class="level.form_type">
                        <label class="form-check-label">
                            <input type="radio" class="form-check-input" :value="level.value" v-model="filter.level">
                            {{ level.label }}
                            <i class="input-helper"></i>
                        </label>
                    </div>
                </div>

                <div class="text-center text-md-left">
                    <button class="btn btn-outline-dark mt-3" @click="getFilteredVideos">
                        {{ $t('pages.gym.apply_filter') }}
                    </button>
                    <button class="btn text-secondary mt-3" @click="clearFilters">
                        {{ $t('pages.gym.clear_filter') }}
                    </button>
                </div>
            </div>
        </div>

        <div class="row">
            <div class="col-lg-12 grid-margin">
                <div class="row">
                    <div class="col-md-6 stretch-card grid-margin">
                        <gym-view-mode :title="$t('pages.gym.newest_videos')" icon="mdi-clock" mode="newest" :selected.sync="activeViewMode"></gym-view-mode>
                    </div>

                    <div class="col-md-6 stretch-card grid-margin">
                        <gym-view-mode :title="$t('pages.gym.not_completed')" icon="mdi-decagram-outline" mode="uncompleted" :selected.sync="activeViewMode"></gym-view-mode>
                    </div>
                </div>


                <static-loading-indicator-icon :loading="$store.getters.shouldLoadLocal"/>
                <div v-if="!$store.getters.shouldLoadLocal">
                    <div>
                        <div class="row" v-if="!videos.length && filterActive">
                            <div class="col-md-12">
                                <div class="alert alert-secondary border-dark pt-3 pb-3 mb-5">
                                    {{ $t('pages.gym.no_videos_matching_filter') }}
                                </div>
                            </div>
                        </div>

                        <div class="row" v-if="videos.length && filterActive">
                            <div class="col-md-12">
                                <div class="alert alert-secondary border-dark pt-3 pb-3 mb-5">
                                    {{ $tc('pages.gym.videos_matching_filter', totalVideosFound, {amount: totalVideosFound}) }}
                                </div>
                            </div>
                        </div>

                        <div class="row">
                            <div class="col-md-4 mb-5" v-for="video in videos" :key="video.id">
                                <gym-video-card-new :video="video" :page-link-enabled="true"/>
                            </div>
                        </div>

                        <div class="mt-3">
                            <pagination :data="paginationData" @pagination-change-page="getVideos" align="center"></pagination>
                        </div>
                    </div>
                </div>
            </div>
        </div>

    </div>
</template>

<script>
import PageHeader from "../Includes/PageHeader";
import GymRepository from "../../repositories/Gym/GymRepository";
import GymVideoCardNew from "./Includes/GymVideoCardNew";
import StaticLoadingIndicatorIcon from "../Includes/StaticLoadingIndicatorIcon";
import GymVideoLevelBadge from "./Includes/Badges/GymVideoLevelBadge";
import RangeSlider from 'vue-range-slider'
import GymViewMode from "./Includes/GymViewMode";
import GoalRepository from "../../repositories/Goal/GoalRepository";
export default {
name: "Gym.vue",
    components: {GymViewMode, GymVideoLevelBadge, StaticLoadingIndicatorIcon, GymVideoCardNew, PageHeader, RangeSlider},
    data: () => ({
        videos: [],
        filter: {
            level: null,
            max_intensity: 10,
            max_duration: 75,
            goals: [],
            search: ''
        },
        filterActive: false,
        goals: [],

        activeViewMode: 'newest',
        hoveredViewMode: '',

        totalVideosFound: 0,

        paginationData: {},
    }),
    computed: {
        levels() {
            return [
                {value: null, label: this.$t('pages.gym.level_all'),        form_type: 'form-check-dark'},
                {value: 1, label: this.$t('pages.gym.level_fundamental'),   form_type: 'form-check-primary'},
                {value: 2, label: this.$t('pages.gym.level_challenge'),      form_type: 'form-check-warning'},
                {value: 3, label: this.$t('pages.gym.level_advanced'),     form_type: 'form-check-danger'}
            ];
        }
    },
    watch: {
        activeViewMode: function(val) {
            this.getVideos();
        }
    },
    methods: {
        getFilteredVideos() {
            this.activeViewMode = 'newest';
            GymRepository
                .getFilteredVideos(this.filter)
                .then((res) => {
                    this.videos = res.data.data;
                    this.filterActive = true;

                    this.totalVideosFound = res.data.meta.total;
                    this.paginationData = res.data.meta;
                });
        },
        clearFilters() {
            this.getVideos().then(() => {
                this.filter = {
                    level: null,
                    max_intensity: 10,
                    max_duration: 75,
                    focus: [],
                    search: ''
                };
            });
        },
        getGoals() {
            GoalRepository.getGoals().then((res) => {
                this.goals = res.data;
            });
        },
        getVideos(page = 1) {
            this.filterActive = false;
            return GymRepository
                .getVideos(page, this.activeViewMode)
                .then((res) => {
                    this.videos = res.data.data;
                    this.filterActive = false;

                    this.totalVideosFound = res.data.meta.total;
                    this.paginationData = res.data.meta;
                });
        },
    },
    mounted() {
        this.getVideos();
        this.getGoals();
    },
}
</script>

<style scoped>
</style>
